import StyleSheet from '../../../utils/helpers/styleSheet'
import {v4 as uuidv4} from 'uuid'
import {ImgCaption} from '../../../models/editor/imgCaption'
import {origo} from '../../../utils/helpers/origo'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {
  addImageHistoryItem,
  addImageSelected,
} from '../../../stores/editor/editor.reducer'
import PlusIcon from '../../icons/PlusIcon'
import {selectToolboxTabPanel} from '../../../stores/toolbox/toolbox.reducer'
import {IMG_ADDED} from '../../../models/editor/imgHistoryItemAction'
import {useTranslation} from 'react-i18next'

const styles: StyleSheet = {
  button: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 15,
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    cursor: 'pointer',
    height: '30px',
  },
  text: {
    textAlign: 'center',
    minWidth: 110,
  },
}

interface AddCaptionButtonProps {
  singleLine?: boolean
}

export default function AddCaptionButton({
  singleLine = false,
}: AddCaptionButtonProps) {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {printArea} = useAppSelector(store => store.editor)

  return (
    <div
      style={styles.button}
      onClick={() => {
        const newCaption: ImgCaption = {
          id: uuidv4(),
          type: 'caption',
          position: printArea?.position ?? origo,
          caption1: singleLine ? t('Szöveg helye') : t('Első sor'),
          caption2: singleLine ? null : t('Második sor'),
          width: 0,
          height: 0,
          fontFamily: 'Aclonica',
          color: '#000000',
          bold: false,
          italic: false,
          underline: false,
          scale: 6,
          rotation: 0,
          brightness: 1,
          mirroredX: false,
          mirroredY: false,
          inert: false,
          locked: false,
          curvatureLevel: 0,
          letterSpacing1: 0,
          letterSpacing2: 0,
          filters: {
            inverse: false,
            monochrome: false,
            sepia: false,
          },
        }
        dispatch(addImageSelected({image: newCaption}))
        dispatch(
          addImageHistoryItem({item: {img: newCaption, action: IMG_ADDED}}),
        )
        dispatch(selectToolboxTabPanel({tabPanel: 'Edit'}))
      }}>
      <PlusIcon
        title={t('Hozzáadás')}
        style={styles.icon}
        className="icon"
        width={30}
        height={30}
      />
      <span style={styles.text} className={'text'}>
        {t('Hozzáadás')}
      </span>
    </div>
  )
}
